/* eslint-disable no-unused-vars */
import { observer } from "mobx-react-lite";
import { useStore } from "../../../../../root-store-context";
import * as React from "react";
import { Button, Collapse, CollapseProps, Flex } from "antd";
import styles from "./RecipientItem.module.scss";
import { RecipientItemBody } from "./RecipientItemBody";
import { MailJobFile } from "../../../../../stores/AppStore/ApplicationStore";
import { RcFile } from "antd/es/upload";

export const RecipientItem = observer(
  (props: { recipientItems: MailJobFile[] }) => {
    const { applicationStore, modalViewerStore } = useStore();

    const openViewFile = (file: RcFile) => {
      const blob = new Blob([file], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(blob);
      modalViewerStore.openFileByUrl(fileURL, "Recipient Info.pdf");
    };

    const items: CollapseProps["items"] = [
      ...props.recipientItems.map((_) => ({
        key: _.guid,
        label: (
          <Flex
            className={styles.recipientHeader}
            align="center"
            justify="space-between"
          >
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                openViewFile(_.file);
              }}
            >
              {_.name}
            </a>
            <Button
              data-testid={`cam-delete-recipient-btn-${_.guid}`}
              className="cam__button-danger-sm"
              type="primary"
              danger
              style={{ flexShrink: 0 }}
              onClick={() => {
                applicationStore.setSelectedFiles([_.guid]);
                applicationStore.deleteFiles();
              }}
            >
              Delete
            </Button>
          </Flex>
        ),
        children: <RecipientItemBody guid={_.guid} />,
      })),
    ];

    const defaultKeys = props.recipientItems.length > 0
      ? [props.recipientItems[0].guid]
      : [];

    return <Collapse items={items} defaultActiveKey={defaultKeys} />;
  }
);